import gsap from 'gsap';
import { PageEvent } from './page-lifecycle/PageEvent';
import { stAnimation, STAnimationType } from '../utils/ScrollTriggerHelper';

const ALLOW_PARALLAX_FUNCTIONALITY: boolean = false;

export class HHDSFooter {
	private _element: HTMLElement | null = null;
	private _parallaxTween: gsap.core.Tween | null = null;

	constructor() {}

	init(): void {
		this._element = document.querySelector('.footer') as HTMLElement;

		if (ALLOW_PARALLAX_FUNCTIONALITY) {
			document.addEventListener(PageEvent.enter, (_event: any) => {
				requestAnimationFrame(() => {
					if (this._element) this.configureParallax(this._element);
				});
			});
		}
	}

	private configureParallax(triggerElement: HTMLElement): void {
		this._parallaxTween?.kill();
		const parallaxContent = document.querySelector('.footer__content') as HTMLElement;
		if (parallaxContent) {
			this._parallaxTween = stAnimation(parallaxContent, STAnimationType.bidirectional, {
				scrollTarget: triggerElement,
				start: '0%',
				end: '100%',
				manualUpdate: (progress: number) => {
					const textHeight = parallaxContent.clientHeight;
					const screenHeight = window.innerHeight;
					const ratio = textHeight / screenHeight;

					// Obtain a ratio of textHeight to screenHeight, where ratios below 0
					// (that have enough space) are unaffected, but ratios are exaggerated
					// exponentially by how much they exceed 1, to help quick reveal of text
					// on mobile layouts.
					const ratioExcess = Math.max(0, ratio - 1);
					const exponentialRatio = Math.pow(1 + ratioExcess, 4);

					// Desired yOffset is an arbitrary amount (quarter screen height) reduced by the
					// calculated ratio, as we don't want as much movement when text height is too tall
					// in comparison to the footer container.
					const yOffset = screenHeight / 4 / exponentialRatio;

					// Remap the progress using this ratio, clamping it to 1; this means the parallax can
					// end earlier, e.g. once 30% of the footer is in screen rather than the default of 100% .
					const remappedProgress = Math.min(1, progress * exponentialRatio);

					// Use the inverse of the progress because we want 0*yOffset when the scroll
					// tween completes, and maximum offset (1*yOffset) when the scroll tween starts.
					const inverseProgress = 1 - remappedProgress;
					const yValue = inverseProgress * -yOffset;

					gsap.set(parallaxContent, { y: yValue });
				},
			});
		}
	}

	destroy(): void {
		if (ALLOW_PARALLAX_FUNCTIONALITY) {
			this._parallaxTween?.scrollTrigger?.kill();
			this._parallaxTween?.kill();
			this._parallaxTween = null;
		}
	}
}

export default new HHDSFooter();
